export { default } from './FullScreenModalLayoutFooter';
